import {
  WhatsappMessageTemplate,
  WhatsappMessageTemplateComponent,
} from "../../../../apps/web/src/lib/types/api/whatsapp.type";
import { MessageType, UserConversationRoleEnum } from "../enums";
import { Content, Conversation } from "./conversation.types";
import { BroadcastWhatsAppTemplate } from "../../../../apps/web/src/schemas/broadcast.schema";
import { CollectFormNodeSchema } from "@aichat/flow-config";

export type MessageResponse = {
  id: string;
  content: Content;
  role: UserConversationRoleEnum;
  conversationId: string;
  type: MessageType;
  liveChatAgentUserId: string | null;
  feedback: string | null;
  meta: any | null;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
};

export type MessageStreamingResponse = string;

export type MessageStreamingEndResponse = MessageContent;

export type MessageEmit = {
  conversationId?: string;
  role?: UserConversationRoleEnum;
  message: {
    text?: string;
    attachments?: MessageAttachment[];
    form_response?: Record<string, string | string[] | number | Date | boolean>;
  };
};

export type CustomerJoinRoomEmit = {
  isPlayground?: boolean;
  userId?: string | null;
};

export type ReadMessageEmit = {
  conversationId: string;
};

// --- NEW ---
export type ChatResponse = {
  messages: MessageContent[];
  tokenValue: string;
  conversation: Conversation;
  cookieName: string;
  expiresIn: string;
};

export type MessageContent = {
  id?: string;
  conversationId?: string;
  meta?: {
    isWhatsappTemplate?: boolean;
    liveChatId?: string;
  };
  content: {
    text?: string;
    system_message?: string;
    buttons?: ButtonComponent[];
    carousel?: CarouselComponent;
    citations?: CitationComponent[];
    link_preview?: LinkPreviewComponent[];
    product_carousel?: ProductCarouselComponent[];
    medias?: MediaComponent[];
    attachments?: MessageAttachment[];
    link_buttons?: LinkButtonComponent[];
    form_component?: CollectFormNodeComponent;

    parameterMapping?: {
      name: string;
      language: { code: string };
      components: WhatsappMessageTemplateComponent[];
    };
    whatsappTemplate?: WhatsappMessageTemplate;
    parameters?: BroadcastWhatsAppTemplate["template"];
  };
  liveAgentUser?: LiveAgent;
  createdAt: string;
  role: UserConversationRoleEnum;
};

export type MessageAttachment = {
  url?: string;
  type: "image" | "video" | "audio" | "file";
  name?: string;
};

// export type MessageContent = CommonMessageContent &
//   (WebMessageContent | WhatsappTemplateMessageContent);

export type ErrorResponse = {
  details?: string;
  message: string;
};

export type LiveAgent = {
  avatarUrl?: string;
  name: string;
};

export type ButtonComponent = {
  id: string;
  label: string;
  payload: ButtonPayload;
};

export type CollectFormNodeComponent = {
  flow_id: string;
  config: CollectFormNodeSchema;
};

export type LinkButtonComponent = {
  button_label: "";
  button_link: "";
};

export type QuickReplyComponent = {
  label: string;
  payload: string;
};

export type ButtonPayload = {
  type: ButtonPayloadEnum;
  value: string;
};

export enum ButtonPayloadEnum {
  REPLY = "quick_reply",
  STARTER = "starter",
  LINK = "link",
}

export type CarouselComponent = {
  id: string;
  items: CarouselItem[];
  globalButton: ButtonComponent;
};

export type CarouselItem = {
  id: string;
  price: CarouselPrice;
  title: string;
  buttons: ButtonComponent[];
  imageUrl?: string;
  subtitle: string;
  description: string;
};

export type CarouselPrice = {
  amount: number;
  currency: string;
};

export type CitationComponent = {
  url: string;
  title: string;
  favicon: string;
  domainName: string;
  description: string;
};

export type MediaComponent = {
  url: string;
  alt_text?: string;
};

export type LinkPreviewComponent = {
  url: string;
  title: string;
  description: string;
  image: string;
  button_label?: string;
};

export type ProductCarouselComponent = {
  title: string;
  product_type?: string;
  image?: string;
  url?: string;
  description?: string;
  price?: number;
  currency?: string;
  vendor?: string;
  buttonLabel?: string;
};

export type SurveyComponent = {
  usedFor: "BOT" | "LIVE_AGENT";
  previousAgentInfo?: {
    agentId: string;
    agentName: string;
  };
  component: {
    csat: {
      enabled: boolean;
      question_title: string;
    };
    nps: {
      enabled: boolean;
      question_title: string;
    };
    additional_feedback_title: string;
  };
};

// --- Component Agnostic type ---
export type LinkPreviewComponentType = {
  type: "link_preview";
  data: LinkPreviewComponent[];
};

export type ProductCarouselComponentType = {
  type: "product_carousel";
  data: ProductCarouselComponent[];
};

export type ButtonComponentType = {
  type: "button";
  data: ButtonComponent[];
};

export type QuickReplyComponentType = {
  type: "quick_reply";
} & QuickReplyComponent;

export type QuickReplyCollectionType = {
  type: "quick_reply_collection";
  data: QuickReplyComponent[];
};

export type CarouselComponentType = {
  type: "carousel";
  data: CarouselComponent;
};

export type CitationComponentType = {
  type: "citation";
  data: CitationComponent[];
};

export type MediaComponentType = {
  type: "media";
} & MediaComponent;

export type SurveyComponentType = {
  type: "survey";
} & SurveyComponent;

export type MessageComponentResponse =
  | ProductCarouselComponentType
  | LinkPreviewComponentType
  | ButtonComponentType
  | QuickReplyComponentType
  | CarouselComponentType
  | CitationComponentType
  | MediaComponentType
  | QuickReplyCollectionType
  | SurveyComponentType;

export enum LiveChatState {
  ENDING,
  SHOULD_END,
  NONE,
}
